document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-celvian-reviews]").forEach(initReviews);
});

function initReviews(root) {
  const productId = root.dataset.productId;
  const formWrap = root.querySelector("[data-review-form-wrap]");
  const form = root.querySelector("[data-review-form]");
  const openBtn = root.querySelector("[data-open-review-form]");
  const grid = root.querySelector("[data-review-grid]");
  const score = root.querySelector("[data-review-score]");
  const scoreStars = root.querySelector("[data-score-stars]");
  const count = root.querySelector("[data-review-count]");
  const message = root.querySelector("[data-review-message]");
  const ratingValue = root.querySelector("[data-rating-value]");
  const starButtons = root.querySelectorAll("[data-star]");
  const textArea = root.querySelector("[data-review-text]");
  const countdown = root.querySelector("[data-review-countdown]");
  const fileInput = root.querySelector("[data-photo-input]");
  const preview = root.querySelector("[data-photo-preview]");
  const dropzone = root.querySelector("[data-dropzone]");
  const lightbox = root.querySelector("[data-review-lightbox]");
  const lightboxImage = root.querySelector("[data-lightbox-image]");
  const loadMoreWrap = root.querySelector("[data-load-more-wrap]");
  const loadMoreBtn = root.querySelector("[data-load-more-reviews]");

  let summary = null;
  let activeMetric = "comfort";
  let selectedFiles = [];
  let lightboxZoom = 1;
  let reviewOffset = 0;
  let reviewLimit = 3;
  let hasMoreReviews = false;

  paintStars(5);
  initMetricRanges();

  openBtn?.addEventListener("click", () => {
    formWrap.hidden = !formWrap.hidden;

    if (!formWrap.hidden) {
      formWrap.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  starButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const value = Number(btn.dataset.star || 5);
      ratingValue.value = value;
      paintStars(value);
    });

    btn.addEventListener("mouseenter", () => {
      paintStars(Number(btn.dataset.star || 5), true);
    });
  });

  root.querySelector("[data-star-picker]")?.addEventListener("mouseleave", () => {
    paintStars(Number(ratingValue.value || 5));
  });

  function paintStars(value, previewMode) {
    starButtons.forEach((btn) => {
      const active = Number(btn.dataset.star) <= value;
      btn.classList.toggle("is-active", active);
      btn.classList.toggle("is-preview", previewMode && active);
    });
  }

  function initMetricRanges() {
    root.querySelectorAll(".celv-metric-control input[type='range']").forEach((range) => {
      const label = range.closest(".celv-metric-control")?.querySelector("[data-range-value]");

      const update = () => {
        const labels = String(range.dataset.rangeLabels || "").split("|");
        const index = Math.max(0, Math.min(labels.length - 1, Number(range.value) - 1));
        if (label) label.textContent = labels[index] || range.value;

        const percent = ((Number(range.value) - 1) / 4) * 100;
        range.style.setProperty("--range-progress", `${percent}%`);
      };

      range.addEventListener("input", update);
      update();
    });
  }

  root.querySelectorAll("[data-metric]").forEach((btn) => {
    btn.addEventListener("click", () => {
      root.querySelectorAll("[data-metric]").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      activeMetric = btn.dataset.metric;
      renderScale(root, summary, activeMetric);
    });
  });

  textArea?.addEventListener("input", () => {
    countdown.textContent = textArea.value.length;
  });

  if (countdown && textArea) {
    countdown.textContent = textArea.value.length;
  }

  fileInput?.addEventListener("change", () => {
    addSelectedFiles(fileInput.files);
    fileInput.value = "";
  });

  ["dragenter", "dragover"].forEach((eventName) => {
    dropzone?.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropzone.classList.add("is-dragging");
    });
  });

  ["dragleave", "drop"].forEach((eventName) => {
    dropzone?.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropzone.classList.remove("is-dragging");
    });
  });

  dropzone?.addEventListener("drop", (event) => {
    event.preventDefault();
    addSelectedFiles(event.dataTransfer.files);
  });

  preview?.addEventListener("click", (event) => {
    const removeBtn = event.target.closest("[data-remove-photo]");
    if (!removeBtn) return;

    const index = Number(removeBtn.dataset.removePhoto);
    selectedFiles.splice(index, 1);
    renderPhotoPreview();
  });

  function addSelectedFiles(fileList) {
    const incoming = Array.from(fileList || []);

    for (const file of incoming) {
      if (selectedFiles.length >= 3) {
        message.textContent = "You can upload maximum 3 photos.";
        message.classList.add("is-error");
        break;
      }

      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        message.textContent = "Only JPG, PNG and WebP images are allowed.";
        message.classList.add("is-error");
        continue;
      }

      if (file.size > 5 * 1024 * 1024) {
        message.textContent = "Each photo must be under 5 MB.";
        message.classList.add("is-error");
        continue;
      }

      selectedFiles.push(file);
    }

    renderPhotoPreview();
  }

  function renderPhotoPreview() {
    if (!preview) return;

    if (!selectedFiles.length) {
      preview.innerHTML = "";
      return;
    }

    preview.innerHTML = selectedFiles.map((file, index) => {
      const url = URL.createObjectURL(file);

      return `
        <div class="celv-preview-item">
          <button type="button" class="celv-remove-photo" data-remove-photo="${index}" aria-label="Remove photo">×</button>
          <img src="${url}" alt="">
          <span>${escapeHtml(file.name)}</span>
        </div>
      `;
    }).join("");
  }

  form?.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (selectedFiles.length > 3) {
      message.textContent = "You can upload maximum 3 photos.";
      message.classList.add("is-error");
      return;
    }

    for (const file of selectedFiles) {
      if (file.size > 5 * 1024 * 1024) {
        message.textContent = "Each photo must be under 5 MB.";
        message.classList.add("is-error");
        return;
      }
    }

    const submitBtn = form.querySelector("button[type='submit']");
    const fd = new FormData(form);

    fd.delete("photos");
    selectedFiles.forEach((file) => {
      fd.append("photos", file, file.name);
    });

    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
    message.textContent = "";
    message.classList.remove("is-error");

    try {
      const res = await fetch("/apps/celvian-reviews/submit", {
        method: "POST",
        body: fd
      });

      const data = await readJsonSafe(res);

      if (!res.ok) {
        message.textContent = data.error || "Something went wrong.";
        message.classList.add("is-error");
        return;
      }

      form.reset();
      selectedFiles = [];
      renderPhotoPreview();
      ratingValue.value = 5;
      paintStars(5);
      initMetricRanges();
      if (countdown) countdown.textContent = "0";

      message.textContent = data.message || "Thanks — your review is pending approval.";
      message.classList.remove("is-error");
    } catch (error) {
      message.textContent = error.message || "Could not submit review. Please try again.";
      message.classList.add("is-error");
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit review";
    }
  });

  grid?.addEventListener("click", (event) => {
    const btn = event.target.closest("[data-review-photo]");
    if (!btn) return;

    openLightbox(btn.dataset.reviewPhoto, btn.dataset.reviewPhotoAlt || "Celvian review photo");
  });

  root.querySelector("[data-lightbox-close]")?.addEventListener("click", closeLightbox);

  lightbox?.addEventListener("click", (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && lightbox && !lightbox.hidden) closeLightbox();
  });

  root.querySelector("[data-lightbox-zoom-in]")?.addEventListener("click", () => {
    lightboxZoom = Math.min(3, lightboxZoom + 0.25);
    applyLightboxZoom();
  });

  root.querySelector("[data-lightbox-zoom-out]")?.addEventListener("click", () => {
    lightboxZoom = Math.max(1, lightboxZoom - 0.25);
    applyLightboxZoom();
  });

  root.querySelector("[data-lightbox-zoom-reset]")?.addEventListener("click", () => {
    lightboxZoom = 1;
    applyLightboxZoom();
  });

  lightboxImage?.addEventListener("click", () => {
    lightboxZoom = lightboxZoom === 1 ? 2 : 1;
    applyLightboxZoom();
  });

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImage) return;

    lightboxZoom = 1;
    lightboxImage.src = src;
    lightboxImage.alt = alt;
    applyLightboxZoom();
    lightbox.hidden = false;
    document.body.classList.add("celv-lightbox-open");
  }

  function closeLightbox() {
    if (!lightbox || !lightboxImage) return;

    lightbox.hidden = true;
    lightboxImage.src = "";
    document.body.classList.remove("celv-lightbox-open");
  }

  function applyLightboxZoom() {
    if (!lightboxImage) return;
    lightboxImage.style.transform = `scale(${lightboxZoom})`;
  }

  loadMoreBtn?.addEventListener("click", () => {
    loadReviews(false);
  });

  loadReviews();

  async function loadReviews(reset = true) {
    try {
        if (reset) {
        reviewOffset = 0;
        grid.innerHTML = "";
        }

        if (loadMoreBtn) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = "Loading...";
        }

        const res = await fetch(
        `/apps/celvian-reviews/product?product_id=${encodeURIComponent(productId)}&limit=${reviewLimit}&offset=${reviewOffset}`
        );

        const data = await readJsonSafe(res);

        summary = data.summary || {};

        const rating = Number(summary.rating || 0);
        score.textContent = rating.toFixed(1);
        renderScoreStars(scoreStars, rating);

        count.textContent = summary.count
        ? `Based on ${summary.count} review${summary.count === 1 ? "" : "s"}`
        : "No reviews yet";

        renderScale(root, summary, activeMetric);

        const reviews = data.reviews || [];

        if (reset) {
        renderCards(grid, reviews, true);
        } else {
        renderCards(grid, reviews, false);
        }

        hasMoreReviews = !!data.pagination?.has_more;
        reviewOffset = Number(data.pagination?.next_offset || reviewOffset + reviewLimit);

        if (loadMoreWrap) {
        loadMoreWrap.hidden = !hasMoreReviews;
        }

        if (loadMoreBtn) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "Load more reviews";
        }
    } catch (error) {
        grid.innerHTML = `<div class="celv-empty">Reviews could not load right now.</div>`;

        if (loadMoreWrap) {
        loadMoreWrap.hidden = true;
        }
    }
  }
}

async function readJsonSafe(res) {
  const text = await res.text();
  const trimmed = text.trim();

  try {
    return JSON.parse(trimmed);
  } catch (error) {
    if (trimmed.startsWith("<!doctype") || trimmed.startsWith("<html") || trimmed.includes("<body")) {
      return {
        error: "Server error. The review was not submitted. Check Worker logs for the real reason."
      };
    }

    return {
      error: trimmed.slice(0, 300) || `Request failed with status ${res.status}`
    };
  }
}

function renderScoreStars(container, rating) {
  if (!container) return;

  const percent = Math.max(0, Math.min(100, (Number(rating || 0) / 5) * 100));
  container.setAttribute("aria-label", `${Number(rating || 0).toFixed(1)} out of 5 stars`);

  const fill = container.querySelector(".celv-stars-fill");
  if (fill) fill.style.width = `${percent}%`;
}

function renderScale(root, summary, metric) {
  const labels = {
    comfort: ["Very uncomfortable", "OK", "Very comfortable"],
    length: ["Too short", "Spot on", "Too long"],
    value_score: ["Very poor", "OK", "Excellent"],
    sizing: ["Too tight", "True to size", "Too loose"],
    quality: ["1 Star", "3 Star", "5 Star"]
  };

  const value = Number(summary?.[metric] || 3);
  const percent = Math.max(0, Math.min(100, ((value - 1) / 4) * 100));

  root.querySelector("[data-scale-left]").textContent = labels[metric][0];
  root.querySelector("[data-scale-mid]").textContent = labels[metric][1];
  root.querySelector("[data-scale-right]").textContent = labels[metric][2];
  root.querySelector("[data-scale-marker]").style.left = `${percent}%`;
}

function renderCards(grid, reviews, replace = true) {
  if (!reviews.length && replace) {
    grid.innerHTML = `<div class="celv-empty">No approved reviews yet. Be the first to review this product.</div>`;
    return;
  }

  const html = reviews.map((r) => {
    const rating = Number(r.rating || 0);

    const photos = (r.photos || []).map((p) => p.image_url ? `
      <button type="button" class="celv-review-photo-button" data-review-photo="${escapeHtml(p.image_url)}" data-review-photo-alt="${escapeHtml(p.alt || "Celvian review photo")}">
        <img src="${escapeHtml(p.image_url)}" alt="${escapeHtml(p.alt || "Celvian review photo")}" loading="lazy">
      </button>
    ` : "").join("");

    const avatar = r.author_avatar_url
      ? `<img src="${escapeHtml(r.author_avatar_url)}" alt="">`
      : `${escapeHtml(r.author_initials || initialsFromName(r.author_name))}`;

    return `
      <article class="celv-review-row">
        <aside class="celv-review-person">
          <div class="celv-review-avatar">${avatar}</div>
          <div class="celv-review-person-info">
            <strong>${escapeHtml(r.author_name)}</strong>
            ${r.verified_buyer ? `<span class="celv-verified">Verified buyer</span>` : ""}
            ${r.size_purchased ? `<span class="celv-small">Size ${escapeHtml(r.size_purchased)}</span>` : ""}
          </div>
        </aside>

        <div class="celv-review-content">
          <div class="celv-review-rating">
            <b>${rating}</b>
            <span>${"★".repeat(rating)}${"☆".repeat(5 - rating)}</span>
            <small>${timeAgo(r.created_at)}</small>
          </div>

          <h3>${escapeHtml(r.title)}</h3>
          <p>${escapeHtml(r.body)}</p>

          <div class="celv-review-tags">
            <span>Comfort: ${escapeHtml(r.comfort_label || "")}</span>
            <span>Length: ${escapeHtml(r.length_label || "")}</span>
            <span>Value: ${escapeHtml(r.value_label || "")}</span>
            <span>Sizing: ${escapeHtml(r.sizing_label || "")}</span>
            <span>Quality: ${escapeHtml(r.quality_label || "")}</span>
          </div>

          ${photos ? `<div class="celv-review-photos">${photos}</div>` : ""}
        </div>
      </article>
    `;
  }).join("");

  if (replace) {
    grid.innerHTML = html;
  } else {
    grid.insertAdjacentHTML("beforeend", html);
  }
}

function initialsFromName(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);

  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return "CV";
}

function timeAgo(dateString) {
  const date = new Date(dateString);
  const diff = Date.now() - date.getTime();
  const days = Math.floor(diff / 86400000);

  if (days < 1) return "Today";
  if (days === 1) return "1 day ago";
  if (days < 30) return `${days} days ago`;

  return date.toLocaleDateString();
}

function escapeHtml(value) {
  return String(value || "").replace(/[&<>"']/g, (m) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  })[m]);
}